@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

.GenericList {
  @extend %font-family-primary;

  border: 1px solid $theme-color-borders;
  border-radius: 4px;
  background-color: $theme-color-background;
  box-sizing: border-box;
  color: $theme-color-text;
  font-size: $font-size-normal;
  list-style-type: none;
  margin: 0;
  padding: 0;

  li {
    margin: 0;
    padding: 6px 16px;
    border-bottom: 1px solid $theme-color-borders;

    &:first-child {
      color: $theme-filter-icon-color;
      font-weight: $font-weight-semibold;
      background-color: $theme-color-sub-background;
      padding: 7px 16px;
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
    }

    &:last-child {
      border-bottom: none;
    }
  }
}

.ContrastHeader {
  background-color: $theme-color-table-header-background !important;
  color: $theme-color-header !important;
}

.GenericListWithFooter {
  .GenericList {
    border-radius: 4px 4px 0 0;
    border-bottom: none;

    li:last-child {
      border-bottom: none;
      border-radius: 0;
    }
  }

  .Footer {
    background-color: $theme-color-sub-background;
    padding: 8px 16px;
    display: flex;
    justify-content: space-between;
    border: 1px solid $theme-color-borders;
    border-radius: 0 0 4px 4px;
  }
}
